(ns ycweb.app.blitz.shipping.quickship
  (:require
   [ycweb.components.forms :as forms]
   [ycweb.components.flow :as flow]
   [ycweb.components.grid :as grid]
   [ycweb.components.transitions :as t]
   [ycweb.components.wrapper :as w]
   [rum.core :as rum]
   [ycweb.util.core :as u]
   [ycweb.components.common :as cmn]
   [ycweb.components.toaster :as toaster]
   [ycweb.util.comms :as comms]))

(def distributor-steps
  [{:key :printer-scan :title "Scan Printer"}
   {:key :packbox-scan :title "Scan Packbox"}])

(def wholesale-steps
  [{:key :printer-scan :title "Scan Printer"}
   {:key :packbox-scan :title "Scan Packbox"}
   {:key :delivery-note :title "Delivery Note"}
   {:key :done :title "Done"}])

(defn company-steps [app-atom]
  (let [company @(rum/cursor app-atom :company)]
    (forms/setup-steps
      (cond
        (= (:name company) "Edison Stone")
        wholesale-steps

        :else
        distributor-steps))))

(rum/defc last-order < rum/reactive [app-atom {:keys [barcode-text]}]
  (let [{:keys [order msg]} (cmn/curact app-atom [:shipping :quickship :lastorder])
        {:keys [refid receivername]} order]
    [:div
     [:div.section
      [:h2.u-text-center
       {:class (u/bem :heading [:standard])}
       "Last Order"
       [:span.heading__subtext
        "Order: " [:b (str (or (:site order) "YC") refid)] " to " receivername]
       [:span.heading__subtext
        "Response: " msg]]]
     [:div
      (when barcode-text
        [:span.heading__subtext.u-text-center
         barcode-text])
      [:div.section grid/barcode-icon]]]))

(defmethod flow/barcode-dispatch-screen :quickship/shipping-done-packbox-scan [_ app-atom scan]
  (grid/dispatch-action app-atom :quickship/shipping-packbox-scan {:scan scan}))

(rum/defc done-packbox-scan < rum/reactive [app-atom]
  (let [steps (company-steps app-atom)]
    (w/wrapper app-atom "Quickship" {:steps steps :step :packbox-scan}
      [(last-order app-atom {})]
      [[:aside.page-body__footer
        [:p.u-text-center
         {:class (u/bem :paragraph [:flush])}
         "Scan another packbox to ship"]]]
      (grid/pos-call-to-action
        {:left-text "Scan Packbox"
         :left-plain true
         :right-text "Done"
         :right-style :call-to-action
         :right-fn #(t/transition-next app-atom :quickship/shipping-printer-scan)}))))

(defmethod flow/render-screen :quickship/shipping-done-packbox-scan [app-atom _]
  (done-packbox-scan app-atom))

(rum/defc check-printer-for-delivery-note < rum/reactive [app-atom]
  (let [steps (company-steps app-atom)]
    (w/wrapper app-atom "Quickship" {:steps steps :step :done}
      [(last-order app-atom {:barcode-text "Scan again to reprint"})]
      [[:div.u-text-center {:class (u/bem :section [:medium])}
        [:div {:class (u/bem :section [:medium])}
         [:h2.u-text-center
          {:class (u/bem :heading [:standard])}
          [:b "Please check the printer for the delivery note"]
          [:i.u-block-center
           {:class (u/bem :icon [:block :enormous :emoticon-happy :3-3])}]]]]]

      (grid/pos-call-to-action
        {:left-text "Scan printer"
         :left-plain true
         :right-text "Done"
         :right-style :call-to-action
         :right-fn #(t/transition-next app-atom :quickship/shipping-printer-scan)}))))

(defmethod flow/barcode-dispatch-screen :quickship/shipping-check-delivery-note [_ app-atom scan]
  (grid/dispatch-action app-atom :quickship/shipping-print-delivery-note
    {:scan scan}))

(defmethod flow/render-screen :quickship/shipping-check-delivery-note [app-atom _]
  (check-printer-for-delivery-note app-atom))

(defmethod grid/action :quickship/shipping-print-delivery-note [app-atom {:keys [scan reprint-counter]} _]
  (toaster/open-overlay app-atom :pos/printing
    {:text "Fetching Documents" :loading-text? false})
  (let [order (cmn/curact app-atom  [:shipping :quickship :lastorder :order])]
    (swap! app-atom assoc-in [:printers scan :transition-to] :quickship/shipping-check-delivery-note)
    (swap! app-atom update-in [:shipping :quickship :reprint-count] inc)
    (comms/send :quickship/print-delivery-note
      {:order-uuid (:uuid order)
       :printer-barcode scan
       :reprint (pos? reprint-counter)})))

(defmethod flow/barcode-dispatch-screen :quickship/shipping-print-delivery-note [_ app-atom scan]
  (let [reprint-counter (cmn/curact app-atom [:shipping :quickship :reprint-count])]
    (grid/dispatch-action app-atom :quickship/shipping-print-delivery-note
      {:scan scan
       :reprint-counter reprint-counter})))

(defmethod grid/action :quickship/skip-delivery-note [app-atom _ _]
  (t/transition-next app-atom :quickship/shipping-printer-scan))

(defn item-list-modal [app-atom]
  (grid/menu-modal app-atom
    {:items
     [{:label "Skip Step: Delivery Note"
       :action :quickship/skip-delivery-note
       :style
       {:full true :large true :negative true
        :text-default true :icon-class :3-2}}

      {:label "Cancel"
       :action :quickship/menu-cancel
       :style
       {:full true :large true :text-link true :on-dark true}}]}))

(rum/defc print-delivery-note < rum/reactive [app-atom]
  (let [steps (company-steps app-atom)]
    (w/wrapper app-atom "Quickship" {:modal-fn item-list-modal :steps steps :step :delivery-note}
      [(last-order app-atom {})]
      [[:aside.page-body__footer
        [:p.u-text-center
         {:class (u/bem :paragraph [:flush])}
         "Print Delivery Note"]]]
      (grid/pos-call-to-action
        {:left-fn #(t/transition-prev app-atom)
         :right-text "Scan Printer"
         :right-plain true}))))

(defmethod flow/render-screen :quickship/shipping-print-delivery-note [app-atom _]
  (print-delivery-note app-atom))

(defmethod comms/receive :quickship/shipping-packbox-scan
  [app-atom {:keys [wholesale? feature-enabled? pending-box-count order msg scan-uuid]}]
  (toaster/close-subtle-progress app-atom)
  (swap! app-atom update-in [:shipping :quickship]
    (fn [quickship]
      (let [lastorder (get-in quickship [:lastorder :order])
            new-order? (and order (not= (:id order) (:id lastorder)))
            updated-order
            (cond
              new-order?
              order

              :else
              lastorder)]
        (assoc quickship
          :scan-uuid scan-uuid
          :reprint-count (if new-order? 0 (:reprint-count quickship))
          :lastorder {:order updated-order :msg msg}))))
  (cond
    (and feature-enabled? wholesale? (zero? pending-box-count))
    (t/transition-next app-atom :quickship/shipping-print-delivery-note)

    :else
    (t/transition-next app-atom :quickship/shipping-done-packbox-scan)))

(defmethod grid/action :quickship/shipping-packbox-scan [app-atom {:keys [scan]} _]
  (toaster/open-subtle-progress app-atom)
  (let [{:keys [printer waybillnumber scan-uuid]} (get-in @app-atom [:shipping :quickship])]
    (comms/send :quickship/shipping-packbox-scan
      {:scan-uuid scan-uuid
       :printer printer
       :waybillnumber waybillnumber
       :scan scan})))

(defmethod flow/barcode-dispatch-screen :quickship/shipping-packbox-scan [_ app-atom scan]
  (grid/dispatch-action app-atom :quickship/shipping-packbox-scan {:scan scan}))

(rum/defc packbox-scan < rum/reactive [app-atom]
  (let [steps (company-steps app-atom)]
    (w/wrapper app-atom "Quickship" {:steps steps :step :packbox-scan}
      [[:div.section
        [:h2.u-text-center
         {:class (u/bem :heading [:standard])}
         "Scan Packbox"]
        grid/barcode-icon]]
      [[:aside.page-body__footer
        [:p.u-text-center
         {:class (u/bem :paragraph [:flush])}
         "Scan a packbox to ship"]]]
      (grid/pos-call-to-action
        {:left-fn #(t/transition-prev app-atom)
         :right-text "Scan Packbox"
         :right-plain true}))))

(defmethod flow/render-screen :quickship/shipping-packbox-scan [app-atom _]
  (packbox-scan app-atom))

(defmethod comms/receive :quickship/shipping-printer-scan [app-atom {:keys [scan-uuid printer]}]
  (toaster/close-subtle-progress app-atom)
  (swap! app-atom update-in [:shipping :quickship] assoc
    :scan-uuid scan-uuid
    :printer printer)
  (t/transition-next app-atom :quickship/shipping-packbox-scan))

(defmethod grid/action :quickship/shipping-printer-scan [app-atom {:keys [scan]} _]
  (toaster/open-subtle-progress app-atom)
  (comms/send :quickship/shipping-printer-scan {:scan scan}))

(defmethod flow/barcode-dispatch-screen :quickship/shipping-printer-scan [_ app-atom scan]
  (grid/dispatch-action app-atom :quickship/shipping-printer-scan {:scan scan}))

(rum/defc printer-scan < rum/reactive [app-atom]
  (let [steps (company-steps app-atom)]
    (w/wrapper app-atom "Quickship" {:steps steps :step :printer-scan}
      [[:div.section
        [:h2.u-text-center
         {:class (u/bem :heading [:standard])}
         "Scan Printer"]
        grid/barcode-icon]]
      [[:aside.page-body__footer
        [:p.u-text-center
         {:class (u/bem :paragraph [:flush])}
         "Scan a printer to start shipping"]]]
      (grid/pos-call-to-action
        {:left-fn #(t/transition-prev app-atom)
         :right-text "Scan Printer"
         :right-plain true}))))

(defmethod flow/render-screen :quickship/shipping-printer-scan [app-atom _]
  (printer-scan app-atom))